"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filesCommon_de_de = void 0;
function filesCommon_de_de() {
    return {
        "files.uploading": "wird hochgeladen...",
        "files.preview": "Vorschau"
    };
}
exports.filesCommon_de_de = filesCommon_de_de;
